import { createStore } from 'vuex'
import { Users } from './users'
import { Exam } from "./exam"
import { Range } from "./range"
import { Practice } from "./practice"
import createPersistedState from 'vuex-persistedstate'

const store = createStore({
  modules: {
    Users,
    Exam,
    Range,
    Practice
  },
  plugins: [
    createPersistedState({
      key: 'my-app-store',
      storage: window.localStorage, 
      paths: ['Users','Exam','Range','Practice']
    })
  ]
})

export default store
